import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import { getQueryParams } from 'app/modules/router/selectors'
import { EndUser } from 'app/modules/endUser/models'
import * as PresenceActions from 'app/modules/presence/actions'
import * as EndUserActions from 'app/modules/endUser/actions'
import * as EndUserSelectors from 'app/modules/endUser/selectors'
import ChatButton from '../ChatButton'
import { AvatarCompat } from 'components/shared/AvatarCompat'


const SessionLength = ({ presenceUser }) => <div><span>{moment.unix(presenceUser.session.activeSessionStartedAt).fromNow(true)}</span></div>

class NewPresenceRow extends Component {

  constructor(props) {
    super(props)

    this.state = {
      hasEndUser: false
    }
  }

  componentDidMount() {
    const id = this.props.user ? this.props.user.get("endUserId") : undefined
    if (id) {
      this.props.actions.fetchEndUser({ id })
    }
  }

  componentWillReceiveProps(nextProps) {
    const { id } = this.props.user.endUser ? this.props.user.endUser : {}
    const { id: nextId } = nextProps.user.endUser ? nextProps.user.endUser : {}

    if (id !== nextId && nextId) {
      this.props.actions.fetchEndUser({ id: nextId })
    }

    const { endUser } = this.props
    const hasEndUser = endUser && endUser.id
    this.setState({
      hasEndUser: hasEndUser
    })
  }

  renderName = () => {
    const { endUser } = this.props
    return (
      <div>
        <AvatarCompat key={endUser.get("id")} user={endUser}/>
        <span className="pr-data-name-label">{endUser.name || endUser.email || 'Site Visitor'}</span>
      </div>
    )
  }

  renderCompanyIcon = visitorPresenceUser => {
    const url = _.get(visitorPresenceUser, 'company.logo', undefined)
    const name = _.get(visitorPresenceUser, 'company.name', undefined)
    return url && <AvatarCompat company={{ name: name, logo: url }} type="company" />
  }

  renderCompany = () => {
    const { hasLiveReveal, user: visitorPresenceUser } = this.props

    if (hasLiveReveal) {
      return (
        <div className="pr-data-company-container">
          {this.renderCompanyIcon(visitorPresenceUser)}
          <span className="pr-data-company-label">{this.companyName(visitorPresenceUser)}</span>
      </div>
      )
    } else {
      return null
    }
  }

  companyName = (visitorPresenceUser) => (visitorPresenceUser.company && visitorPresenceUser.company.name) || '-'

  renderPage = () => {
    const { user } = this.props
    const { url, path, title } = user.page ? user.page : {}
    if (url) {
      if (title) {
        return <a is href={`//${url}`} tooltip={url} flow="right">{title} <span
          className="pr-path-link">{path || "/"}</span></a>
      } else {
        return <a is href={`//${url}`} tooltip={url} flow="right">{path || "/"}</a>
      }
    }
  }

  renderLastUpdate = () => {
    const { user } = this.props

    return <span> {moment(user.updatedAt).fromNow()} </span>
  }

  renderLocation = () => {
    const geo = this.props.user.location
    if (!geo) return

    const location = _.compact([
      geo.city,
      geo.subdivision,
      geo.country,
    ]).join(', ') || ' - '

    return <span title={location}>{location}</span>
  }

  render() {
    const { user } = this.props
    const statusClass = user.className || ''
    let companyName = null
    if (this.props.hasLiveReveal) {
      companyName = (<td className="pr-td pr-data-company">{this.renderCompany()}</td>)
    }
    return (
      <tr className={`pr-tr ${statusClass}`} onClick={ () => this.props.setSelectedUser(user) }>
        <td className="pr-td pr-data-chatbutton">
          <div>
            <ChatButton endUserId={user.endUserId} onClick={() => this.props.setSelectedUser(user)} /> 
          </div>
        </td>
        <td className="pr-td pr-data-name">{this.renderName()}</td>
        {companyName}
        <td className="pr-td pr-data-url">
          <div>{this.renderPage()}</div>
        </td>
        <td className="pr-td pr-data-last-update">
          <SessionLength presenceUser={user}/>
        </td>
        <td className="pr-td pr-data-location">
          <div>{this.renderLocation()}</div>
        </td>
      </tr>
    )
  }
}

const makeMapStateToProps = () => {
  const endUserSelector = EndUserSelectors.makeEndUserSelector()
  const emptyEndUser = new EndUser()
  

  return (state, props) => {
    return {
      endUser: (props.user.endUserId && endUserSelector(state, { id: props.user.endUserId })) || emptyEndUser,
      query: getQueryParams(state),
      hasLiveReveal: props.hasLiveReveal
    }
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchEndUser: EndUserActions.fetchEndUser,
    bootstrapUser: PresenceActions.bootstrapUser
  }, dispatch),
})

export default connect(makeMapStateToProps, mapDispatchToProps)(NewPresenceRow)



// WEBPACK FOOTER //
// ./src/scripts/components/Presence/NewPresenceRow/index.js